import axios from 'axios'
import crypto from 'crypto'
import md5 from 'MD5'

function isEmpty(obj) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false
        }
    }

    return true
}

export async function axiosPost(url, body, headers = null, config = null) {
    return new Promise(async (resolve, reject) => {
        try {
            if (body && !isEmpty(body)) {
                var random_value = Math.random().toString().replace('.', '')
                var dynamic_key = md5(md5(random_value) + 'auctionio')
                var cipher = crypto.createCipher('aes-256-ctr', dynamic_key)
                var crypted = cipher.update(JSON.stringify(body), 'utf8', 'hex')
                crypted += cipher.final('hex')
                var crypted_body = {
                    encrypt_request: random_value,
                    encrypt_data: crypted,
                }
                if (headers) {
                    console.log('axiosPost headers', headers)
                    axios.defaults.headers = headers
                }
                axios.post(url, crypted_body, config).then(function (response) {
                    if (response && response.data && response.data.encrypt_response) {
                        var decipher = crypto.createDecipher('aes-256-ctr', dynamic_key)
                        var dec = decipher.update(response.data.encrypt_data, 'hex', 'utf8')
                        dec += decipher.final('utf8')
                        try {
                            var decrypted_response = JSON.parse(dec)
                            response.data = decrypted_response
                            resolve(response)
                        } catch (err) {
                            console.log('axiosPost response err', err)
                            resolve(response)
                        }
                    } else {
                        resolve(response)
                    }
                })
            } else {
                return axios.post(url, body, config)
            }
        } catch (err) {
            reject()
        }
    })
}
